/** Stable keys for service-tab mode-switch loading state (one active action per robot). */

export const serviceModeActionKey = {
  catalogCalib: (itemKey: string) => `catalog-calib:${itemKey}`,
  catalogCalibFinish: (itemKey: string) => `catalog-calib-finish:${itemKey}`,
  catalogReset: (itemKey: string) => `catalog-reset:${itemKey}`,
  catalogService: (itemKey: string) => `catalog-service:${itemKey}`,
  catalogServiceStop: (itemKey: string) => `catalog-service-stop:${itemKey}`,
  catalogServiceForceStop: () => 'catalog-service-force-stop',
  catalogServiceStatusCancel: () => 'catalog-service-status-cancel',
  tab: (id: string) => `tab:${id}`,
} as const
